<template>
  <div class="onTheGo-container flex-column justify-content-start">
    <!--    <top-bar></top-bar>-->
    <top-bar
      :title="'随手拍'"
      :right-image="right_image"
      @rightClick="rightClick"
    ></top-bar>
    <div class="content" >
      <!--      <div class="item flex-row justify-content-start">-->
      <!--        <div class="item-left flex-column justify-content-start">-->
      <!--          <div class="item-left-title flex-column justify-content-start">-->
      <!--            <i>中国北方重要生态安全屏障</i>-->
      <!--            <div style="width: 1.26rem;height: 0.01rem;background-color: #ffffff;margin-left: 0.03rem;margin-top: 0.12rem;"></div>-->
      <!--          </div>-->
      <!--          <div class="item-left-details flex-row justify-content-start">-->
      <!--            <img :src="people" alt="" style="width: 0.3rem;height: 0.3rem"/>-->
      <!--            <i>参与人数: 5151</i>-->
      <!--            <img :src="artworkIcon" alt="" style="width: 0.3rem;height: 0.3rem;margin-left: 0.4rem;"/>-->
      <!--            <i>6845</i>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="item-reght flex-column justify-content-end">-->
      <!--          <i>征集中</i>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
        class="item flex-row justify-content-start"
        v-for="(item, index) in dataList"
        :key="index"
        :style="{ backgroundImage: 'url(' + item.src + ')' }"
        @click="select($event, item)"
      >
        <div class="item-left flex-column justify-content-start">
          <div class="item-left-title flex-column justify-content-start">
            <i>{{ item.title }}</i>
            <div
              style="width: 1.26rem;height: 0.01rem;background-color: #ffffff;margin-left: 0.03rem;margin-top: 0.12rem;"
            ></div>
          </div>
          <div class="item-left-details flex-row justify-content-start">
            <img :src="people" alt="" style="width: 0.3rem;height: 0.3rem" />
            <i style="margin-left: 0.04rem;"
              >参与人数:
              {{
                participateInCountMap[item.id]
                  ? participateInCountMap[item.id].length
                  : 0
              }}</i
            >
            <img
              :src="artworkIcon"
              alt=""
              style="width: 0.3rem;height: 0.3rem;margin-left: 0.4rem;"
            />
            <i>
              {{
                imageCountMap[item.id]
                  ? imageCountMap[item.id][0].imageCount
                  : 0
              }}</i
            >
          </div>
        </div>
        <div class="item-reght flex-column justify-content-end">
          <i>征集中</i>
        </div>
      </div>
    </div>
    <div style="background: #001538;height: auto;margin-bottom: 1rem;margin-top: .5rem">
      <img :src="back_end" style="width: 100%;" alt=""/>
    </div>
  </div>
</template>

<script>
import topBar from "../top-bar/index";
import back_01 from "../../assets/home_new/onTheGo/back_01.png";
import back_end from "../../assets/home_new/onTheGo/back_end2.png";
import back_02 from "../../assets/home_new/onTheGo/back_02.png";
import back_03 from "../../assets/home_new/onTheGo/back_03.png";
import back_04 from "../../assets/home_new/onTheGo/back_04.png";
import back_05 from "../../assets/home_new/onTheGo/back_05.png";
import back_06 from "../../assets/home_new/onTheGo/back_06.png";
import back_07 from "../../assets/home_new/onTheGo/back_07.png";
import people from "../../assets/home_new/onTheGo/people.png";
import right_image from "../../assets/home_new/onTheGo/right-image.png";
import likeIcon from "../../assets/home_new/onTheGo/likeIcon.png";
import artworkIcon from "../../assets/home_new/onTheGo/artworkIcon.png";
import { imageStatistics } from "@/api/home";

//随手拍
export default {
  name: "onTheGo",
  components: {
    topBar
  },
  data() {
    return {
      back_end: back_end,
      route: {},
      people: people,
      likeIcon: likeIcon,
      artworkIcon: artworkIcon,
      right_image: right_image,
      images: [back_01, back_02, back_03, back_04, back_05, back_06, back_07],
      dataList: [
        {
          title: "【印·像北疆】之生态安全篇", //中国北方重要生态安全屏障
          comments_count: 0,
          content: "",
          src: back_01,
          id: "A",
          post_id: "5310906",
          time: "2020-04-11 16:59:15",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之安全稳定篇", //祖国北疆安全稳定屏障
          comments_count: 0,
          content: "",
          src: back_02,
          id: "B",
          post_id: "5310903",
          time: "2020-04-11 16:09:09",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之能源和战略资源篇", //国家重要能源和战略资源基地
          comments_count: 0,
          content: "",
          src: back_03,
          id: "C",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之农畜产品生产篇", //国家重要农畜产品生产基地
          comments_count: 0,
          content: "",
          src: back_04,
          id: "D",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之向北开放篇", //国际向北开放重要桥头堡
          comments_count: 0,
          content: "",
          src: back_05,
          id: "E",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之民族团结篇", //民族团结
          comments_count: 0,
          content: "",
          src: back_06,
          id: "F",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "【印·像北疆】之青春正能量篇", //青春正能量
          comments_count: 0,
          content: "",
          src: back_07,
          id: "G",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        }
      ],
      participateInCountMap: {},
      imageCountMap: {}
    };
  },
  created() {
    this.route = this.$route.query;
    imageStatistics({})
      .then(res => {
        if (res.code === 1000) {
          this.participateInCountMap = res.result.participateInCountMap;
          this.imageCountMap = res.result.imageCountMap;
        }
      })
      .catch(e => {
        console.info(e);
      });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {},
  methods: {
    rightClick() {
      this.$router.push({ path: "/on_the_go_me_list" });
    },
    goBack() {},
    select(event, item) {
      this.$router.push({ path: "/on_the_go_list?id=" + item.id });
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.onTheGo-container {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  /*background: url(../../assets/home_new/back2.jpg) no-repeat;*/
  background-size: 100% auto;
  background-attachment: fixed;
  overflow-y: auto;
}

.content {
  padding: 0 0.3rem 0 0.3rem;
}

.item {
  width: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-top: 0.1rem;
  height: 2.1rem;
  border-radius: 0.2rem;
}

.item .item-left {
  width: calc(100% - 1rem);
}

.item-left-title {
  height: 2rem;
  color: #ffffff;
  padding-left: 0.5rem;
  font-size: 0.29rem;
  /*font-weight: bold;*/
  padding-top: 0.47rem;
  font-family: JDZY;
}

.item-left-details {
  color: #ffffff;
  padding-left: 0.5rem;
  font-size: 0.2rem;
  padding-bottom: 0.42rem;
  font-family: msg;
}

.item .item-reght {
  width: 1.05rem;
  color: #ffffff;
  font-size: 0.26rem;
  padding-bottom: 0.1rem;
  font-family: msg;
}
</style>
